import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { font, linkEffectForChildren } from '@hivebrite/design-system/Theme';

const CustomContentBox = styled(Box)`
  p {
    margin-bottom: 12px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0.5rem;
  }
  h1 {
    ${(props) => font({ ...props, font: 'h1-regular' })}
  }
  h2 {
    ${(props) => font({ ...props, font: 'h2-regular' })}
  }
  h3 {
    ${(props) => font({ ...props, font: 'h3-regular' })}
  }
  h4 {
    ${(props) => font({ ...props, font: 'h4-regular' })}
  }
  ${linkEffectForChildren}
`;

export default CustomContentBox;
